import { render, staticRenderFns } from "./PullFundsSuccess.vue?vue&type=template&id=b6ad843a&"
import script from "./PullFundsSuccess.vue?vue&type=script&lang=js&"
export * from "./PullFundsSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PullFundsSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports